import React, { useContext, useRef, useState } from "react";
import Logo from "../../assets/images/rearmrobotics-white.png";
import Input from "../../components/DataEntry/Input";
import authService from "../../services/AuthService";
import { useLocation } from "react-router-dom";

const ChangePassword = (props) => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const verificationToken = searchParams.get("code");
  console.log("Verification token", verificationToken);

  const [loading, setLoading] = useState(false);
  const [firstPassword, setFirstPassword] = useState("");
  const [secondPassword, setSecondPassword] = useState("");
  const [error, setError] = useState("");

  // const submitPassword = (event) => {
  //   event.preventDefault();
  //   //call backend
  // };

  const validatePassword = async (e) => {
    console.log("Clicked");
    setLoading(true);
    if (firstPassword != secondPassword) {
      setLoading(false);
      setError("Passwords in both fields must be the same. Please try again.");
    } else if (firstPassword.length == 0 || secondPassword.length == 0) {
      setLoading(false);
      setError("Password field can't be empty field.");
    } else if (fieldValidation(firstPassword)) {
      setError(
        "Invalid password. (min 8 characters, 1 number and 1 special character)"
      );
      setLoading(false);
    } else {
      await authService
        .changePassword(
          {
            password: firstPassword,
            confirmedPassword: secondPassword,
          },
          verificationToken
        )
        .then((response) => {
          if (response.status != 200) {
            setError("Something went wrong. Please try again.");
            setLoading(false);
          } else {
            props.history.push("/login");
          }
        });
      console.log("Sending backend request!");
    }
  };

  const fieldValidation = (password1) => {
    if (
      !password1 ||
      /^(?=.*[a-z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/.test(firstPassword)
    ) {
      return "";
    }
    return "Minimum 8 characters, 1 letter, 1 number and 1 special character.";
  };

  return (
    <div className="change-password">
      <div className="container">
        <img alt="logo" style={{ width: "70%" }} src={Logo} />
        {/* <form onSubmit={submitPassword}> */}
        <span className="title">Change Password</span>
        <span
          style={{
            textAlign: "start",
            marginTop: "2rem",
            display: "flex",
            fontSize: "0.8rem",
          }}
        >
          Password must be 8 characters long and contain a mix of letters,
          numbers and special characters.
        </span>
        <Input
          placeholder="Enter new password"
          className="input-classic"
          type="password"
          onChange={(e) => setFirstPassword(e.target.value)}
          // status={validationErrors?.password && "error"}
          // validationMessage={validationErrors.password}
          // onPressEnter={submitLogin}
        />
        <Input
          placeholder="Re-enter new password"
          className="input-classic"
          type="password"
          onChange={(e) => setSecondPassword(e.target.value)}
          // status={validationErrors?.password && "error"}
          // validationMessage={validationErrors.password}
          // onPressEnter={submitLogin}
        />
        {/* <input
            className="input"
            type="password"
            placeholder="Password"
            value={password}
            onChange={passwordChangeHandler}
          /> */}
        {error.length > 0 && (
          <p
            style={{
              color: "#BE0909",
              margin: "0",
              fontSize: "0.8rem",
              textAlign: "left",
            }}
          >
            {error}
          </p>
        )}
        <button
          className={`button ${loading && "button--loading"}`}
          style={{ margin: "1rem auto" }}
          type="submit"
          onClick={validatePassword}
        >
          SEND
        </button>
        <div></div>
        {/* </form> */}
      </div>
    </div>
  );
};

export default ChangePassword;
